import { DotsThree } from '@phosphor-icons/react'
import useSessionStore from 'Context/useSessionStore'
import { DateDisplay } from 'Organisms'
import { DropdownMenuActions } from 'Organisms/DropdownMenuActions'
import { getRandomDarkThemeColor, getRole } from 'Utils/helperFunctions'
import { PERMISSION_BY_ROLE } from 'Utils/permissionByRol'
import { COLOR_CONTRACT_BLACK } from 'constant/colors'
import { PROFILE_DETAILS_ROUTER } from 'constant/router'
import Avatar from 'react-avatar'
import { Link } from 'react-router-dom'

const TableUserContentDesktop = ({
  listUsers,
  menuOptions,
  selectable = false,
  selectedIds = [],
  onToggleSelect = () => {}
}) => {
  const { user: UserContext } = useSessionStore((state) => ({ user: state.user }))

  // Only whoever can already deactivate a single user gets bulk selection.
  const canSelect = selectable && PERMISSION_BY_ROLE.USER.TABLE.ACTIONS.includes(UserContext.role)
  // Once any row is checked, reveal every checkbox so the rest can be picked
  // without hovering each one individually.
  const selectionActive = canSelect && selectedIds.length > 0

  return (
    <table className={`table align-middle${selectionActive ? ' user-selection-active' : ''}`}>
      <thead>
        <tr>
          <th scope="col">Name</th>
          <th scope="col">Role</th>
          <th scope="col">Position</th>
          <th scope="col">Date added</th>
          <th scope="col">Last active</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        {listUsers.map((user) => {
          const { primary, secondary } = getRandomDarkThemeColor()
          const isSelected = selectedIds.includes(user.id)
          return (
          <tr key={user.id} className={isSelected ? 'user-row-selected' : ''}>
            <td className="user-identity-cell">
              <div className="user-identity">
                {canSelect && user.id !== UserContext?.id && (
                  <input
                    type="checkbox"
                    className="form-check-input user-identity-checkbox"
                    checked={isSelected}
                    onChange={() => onToggleSelect(user.id)}
                    onClick={(e) => e.stopPropagation()}
                    aria-label={`Select ${user.firstname} ${user.lastname}`}
                  />
                )}
                <Avatar
                  className="avatarImage"
                  name={`${user.firstname} ${user.lastname}`}
                  src={user?.logo || null}
                  color={primary}
                  fgColor={secondary}
                  round={true}
                  size="38px"
                  textSizeRatio={3}
                />
                <div>
                  <Link to={PROFILE_DETAILS_ROUTER({ profileId: user.id })}>
                    {user.firstname} {user.lastname}
                  </Link>
                  <br />
                  <span className="form-text">{user.email}</span>
                </div>
              </div>
            </td>
            <td>
              <span className="badge text-bg-secondary">{getRole(user.role)}</span>
            </td>
            <td>
              <span className="text-no-wrap">{user.position}</span>
            </td>
            <td className="text-no-wrap">
              <DateDisplay date={user.created_at} />
            </td>
            <td className="text-no-wrap">
              <DateDisplay date={user.last_activity} />
            </td>
            {PERMISSION_BY_ROLE.USER.TABLE.ACTIONS.includes(UserContext.role) && (
              <td>
                <DropdownMenuActions
                  options={typeof menuOptions === 'function' ? menuOptions(user) : menuOptions}
                  icon={<DotsThree size={18} color={COLOR_CONTRACT_BLACK} weight="bold" />}
                  type="secondary"
                  element={user}
                  idBtn="menuUser"
                />
              </td>
            )}
          </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default TableUserContentDesktop
